module.exports = __webpack_public_path__ + "80abc9b160781ca2e1bf72d4203c5370.png";